import React, {
  createContext, useContext, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';

const initialHasFocus = document.hasFocus();

export const WindowContext = createContext(initialHasFocus);

export function WindowContextProvider({
  children,
}) {
  const [windowIsVisible, setWindowIsVisible] = useState(true);

  useEffect(() => {
    if (document.hidden) {
      setWindowIsVisible(false);
    } else {
      setWindowIsVisible(true);
    }
    // TODO: There's an issue where this event will not fire if the browser takes up the entire screen
    // and the user alt tabs to another program that takes up the entire screen.
    // This event will fire if the user changes browser tabs or if they alt tab to another program that
    // completely covers the browser window (if the browser isn't fullscreen). This should be investigated more,
    // but this should be a good starting point to prevent the server from being bombarded with requests if the user
    // has multiple tabs open
    window.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        setWindowIsVisible(false);
      } else {
        setWindowIsVisible(true);
      }
    });
  }, []);

  return (
    <WindowContext.Provider
      value={{
        windowIsVisible,
      }}
    >
      {children}
    </WindowContext.Provider>
  );
}

WindowContextProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

export default WindowContextProvider;

export function useWindowContext() {
  const context = useContext(WindowContext);

  if (!context) throw new Error('useWindowContext must be called from a WindowContext.Provider');

  return context;
}
